export enum VLWidgetSessionEvent {
  // If you change this routes, please change it signin-callback.html on every project
  SESSION_LOGIN_COMPLETE = 'vl.widget.global_header.citizen_profile.session.login.complete',
  SESSION_LOGIN_FAILURE = 'vl.widget.global_header.citizen_profile.session.login.failure',
}

export enum VLWidgetErrorConstant {
  UNKNOWN_USER = 'UNKNOWN_USER',
}
